















import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import useResponsive from '@shared/composables/useResponsive';
import useUiHelpers from '@shared/composables/useUiHelpers';
import { BaseImage } from '@shared/ui';
import { getStoryblokImageURL } from '@unified-commerce/gpc-vue-storefront-storyblok';

interface Content {
  category: any;
  author: any;
  description: string;
  banner: any;
  title: string;
}

interface Article {
  content: Content;
  full_slug: string;
}

interface FeaturedArticleProps {
  article: Article;
}

export default defineComponent({
  name: 'FeaturedArticle',
  components: { BaseImage },
  props: {
    article: {
      type: Object as PropType<Article>,
      required: true,
    },
  },
  setup(props: FeaturedArticleProps) {
    const { isMobile } = useResponsive();
    const { getPlaceholderImage } = useUiHelpers();
    const placeholderImage = getPlaceholderImage();
    const { content = {} as Content, full_slug = '' } = props.article || {};

    const bannerSrc = computed(
      () => getStoryblokImageURL(content?.banner?.filename) || placeholderImage.filename,
    );

    const bannerAlt = computed(() => content?.banner?.alt || placeholderImage.alt);
    const hasCategory = computed(() => !!content?.category?.content?.title);

    return {
      isMobile,
      title: content?.title,
      description: content?.description,
      category: content?.category,
      author: content?.author,
      link: full_slug,
      hasCategory,
      bannerSrc,
      bannerAlt,
    };
  },
});
